import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { moment } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import type { MailboxListItem } from "@msuite/utils/types";
import { MailboxHealthTag } from "./mailbox-health-tag";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<MailboxListItem>();

/** A timestamp the poll job wrote, or the word for "never" while it has written none. */
function formatPolledAt(value: string | null) {
	if (!value) return localized("mailboxes.never");
	return moment(value).longFormat();
}

export const columns = [
	columnHelper.accessor("label", {
		id: "label",
		header: localized("mailboxes.label"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("emailAddress", {
		id: "emailAddress",
		header: localized("mailboxes.email_address"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor((row) => `${row.imapHost}:${row.imapPort}`, {
		id: "imapHost",
		header: localized("mailboxes.imap_host"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("folder", {
		id: "folder",
		header: localized("mailboxes.folder"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("pollingIntervalMinutes", {
		id: "pollingIntervalMinutes",
		header: localized("mailboxes.polling_interval"),
		cell: (cell) => localized("mailboxes.every_n_minutes", { count: String(cell.getValue()) }),
	}),
	columnHelper.accessor("health", {
		id: "health",
		header: localized("mailboxes.health"),
		cell: (cell) => <MailboxHealthTag mailbox={cell.row.original} />,
	}),
	columnHelper.accessor("lastPolledAt", {
		id: "lastPolledAt",
		header: localized("mailboxes.last_polled_at"),
		cell: (cell) => formatPolledAt(cell.getValue()),
	}),
	columnHelper.accessor("lastSucceededAt", {
		id: "lastSucceededAt",
		header: localized("mailboxes.last_succeeded_at"),
		cell: (cell) => formatPolledAt(cell.getValue()),
	}),
	columnHelper.accessor("emailCount", {
		id: "emailCount",
		header: localized("mailboxes.email_count"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("lastError", {
		id: "lastError",
		header: localized("mailboxes.last_error"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	createRowActions(RowActions),
];
